export default {
  metadata: {
    version: '1.0.0',
    id: 'tab-desktop-1.0.0',
    name: 'JDSTabsDesktop',
    platform: 'web',
    description:
      'Horizontal scrollable tabs is a navigation  device placed at the top of a page or content area that they relate to and can be separated into smaller groups of related information',
    usage:
      'Use this type of tabs to organize related product information on a model landing page.'
  },
  hierarchy: {
    container: [
      {
        'header-container': [
          'prev-jds_button',
          {
            'tablist-container': ['jds_tab_bar']
          },
          'next-jds_button'
        ]
      },
      'content-slot'
    ]
  },
  base: {
    container: {
      'flex-direction': '{t_0}',
      width: '{t_1}'
    },
    jds_tab_bar: {
      width: '{t_2}',
      overflow: 'scroll',
      appearance: 'normal',
      kind: 'label_icon'
    },
    'header-container': {
      'flex-direction': '{t_3}',
      width: '{t_4}',
      'align-items': '{t_5}'
    },
    'prev-jds_button': {
      icon: 'ic_back',
      kind: 'tertiary',
      hidden: true
    },
    'next-jds_button': {
      icon: 'ic_next',
      kind: 'tertiary',
      hidden: true
    },
    'tablist-container': {
      width: '{t_6}',
      overflow: 'scroll'
    }
  },
  variant: {
    overflow: {
      fit: {
        jds_tab_bar: {
          overflow: 'fit'
        },
        'tablist-container': {
          overflow: 'hidden'
        }
      },
      arrows: {
        'prev-jds_button': {
          hidden: false
        },
        'next-jds_button': {
          hidden: false
        },
        'header-container': {
          gap: '{t_7}'
        }
      }
    },
    appearance: {
      tab_bar: {
        jds_tab_bar: {
          appearance: 'tab_bar'
        },
        'header-container': {
          'background-color': '{t_8}'
        }
      }
    },
    _kind: {
      label: {
        jds_tab_bar: {
          kind: 'label'
        }
      },
      icon: {
        jds_tab_bar: {
          kind: 'icon'
        }
      }
    },
    _hideNextBtn: {
      true: {
        'next-jds_button': {
          hidden: true
        }
      }
    },
    _hidePrevBtn: {
      true: {
        'prev-jds_button': {
          hidden: true
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    config: {
      overflow: {
        values: ['scroll', 'fit', 'arrows'],
        doc_dscription:
          'Setting this to true makes the Tab fit the available width.'
      },
      appearance: {
        type: 'JDSTabItem.appearance',
        values: ['normal', 'tab_bar']
      },
      _kind: {
        type: 'JDSTabItem.kind',
        values: ['label_icon', 'label', 'icon']
      },
      _hideNextBtn: {
        values: [false, true]
      },
      _hidePrevBtn: {
        values: [false, true]
      }
    },
    data: {
      jds_tab_bar: {
        items: {
          type: 'list',
          name: 'items',
          object: {
            label: 'string',
            icon: 'icon',
            disabled: 'boolean'
          }
        },
        activeTab: {
          type: 'number',
          name: 'activeTab',
          doc_description:
            'Changes programatically the active tab with animation.'
        }
      }
    },
    events: {
      jds_tab_bar: {
        onChange: 'onChange',
        onScroll: 'onScroll'
      },
      'prev-jds_button': {
        onClick: 'onPrevClick'
      },
      'next-jds_button': {
        onClick: 'onNextClick'
      }
    },
    children: {
      'content-slot': {
        name: 'content',
        accepts: ['template']
      }
    },
    a11y: {
      jds_tab_bar: {
        name: 'items',
        repeating: {
          ariaLabel: 'tabAriaLabel',
          ariaDescribedby: {
            name: 'tabAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      'prev-jds_button': {
        properties: {
          ariaLabel: {
            name: 'previousButtonAriaLabel',
            value: 'Previous Tab'
          }
        }
      },
      'next-jds_button': {
        properties: {
          ariaLabel: {
            name: 'nextButtonAriaLabel',
            value: 'Next Tab'
          }
        }
      }
    }
  }
};
